import * as Yup from 'yup';

export const verifyOTPSchema = Yup.object().shape({
    otp: Yup.string().required('Required'),
});
